import Primrose1 from "../../media/logo/theprimerose.webp";
import Primrose2 from "../../media/logoprimrose .png";

const primroseimages = [Primrose1, Primrose2];

export default primroseimages;
